module.exports = __webpack_public_path__ + "static/media/sixsense-gallery-2.f917eba1.jpg";